import { render, staticRenderFns } from "./PatientPadDakaPage.vue?vue&type=template&id=3d20c716&scoped=true"
import script from "./PatientPadDakaPage.vue?vue&type=script&lang=js"
export * from "./PatientPadDakaPage.vue?vue&type=script&lang=js"
import style0 from "./PatientPadDakaPage.vue?vue&type=style&index=0&id=3d20c716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20c716",
  null
  
)

export default component.exports